import {Component, TemplateRef, ViewChild} from '@angular/core';
import {SidebarService} from "@core/framework/sidebar.service";
import {DemoBottomSheetsComponent} from "@ui/demo/components/bottom-sheets/demo-bottom-sheets.component";

@Component({
    selector: 'app-demo-sidebars',
    templateUrl: './demo-sidebars.component.html',
    styleUrls: ['../../styles/demo-styles.scss']
})
export class DemoSidebarsComponent {

    @ViewChild('template') template: TemplateRef<any>;
    
    constructor(private sidebarService: SidebarService) {
    }

    public OnShowComponentClicked() {
        this.sidebarService.Show("Component", "Component Example", DemoBottomSheetsComponent);
    }
    
    public OnShowTemplateClicked() {
        this.sidebarService.Show("Template", "Template Example", this.template);
    }
    
    public OnCloseTemplateClicked() {
        this.sidebarService.Close("Template");
    }
}
